import React, { useState } from 'react';
import { withRouter } from 'react-router';

import BusinessApi from 'apis/Business';
import Toaster from 'components/Toaster';
import BusinessCardWrapper from './businessCardWrapper';
import BasicInfo from './basicInfo/basicInfo';
import BasicInfoForm from './basicInfo/basicInfoForm';
import BusinessLogo from './basicInfo/businessLogo';

const BusinessBasicInfo = ({
  name,
  website,
  description,
  categories,
  match,
  fetchBusinessDetail,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const onSubmit = values => {
    const { params } = match;
    const { id } = params;
    const { categories } = values;
    const newValues = {
      ...values,
      category_ids: categories.map(({ value }) => value),
    };
    const data = {
      business: newValues,
    };

    BusinessApi.update(id, data)
      .then(() => {
        setIsEditing(false);
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully updated business details'
        );
        fetchBusinessDetail();
      })
      .catch(() =>
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Failed to update business details'
        )
      );
  };

  const iconRight = isEditing ? null : 'pencil-alt';

  return (
    <BusinessCardWrapper
      iconLeft="store"
      title="Business Details"
      iconRight={iconRight}
      onEdit={() => setIsEditing(true)}
    >
      <BusinessLogo name={name} />
      {isEditing ? (
        <BasicInfoForm
          name={name}
          website={website}
          description={description}
          cancelEdit={() => setIsEditing(false)}
          categories={categories}
          onSubmit={onSubmit}
        />
      ) : (
        <BasicInfo
          name={name}
          website={website}
          description={description}
          categories={categories}
        />
      )}
    </BusinessCardWrapper>
  );
};

export default withRouter(BusinessBasicInfo);



// WEBPACK FOOTER //
// ./src/components/businessDetail/businessBasicInfo.js